import { ASSET_PATHS } from '../../utils/assetPath';

import './PNGFileIcon.css';

interface PNGFileIconProps {
  /**
   * Additional CSS class name
   */
  className?: string;
  /**
   * Icon size in pixels
   */
  size?: number;
  /**
   * Accessible label for the icon
   */
  ariaLabel?: string;
}

function PNGFileIcon({ className = '', size = 32, ariaLabel = 'PNG file' }: PNGFileIconProps) {
  return (
    <img
      alt=''
      aria-label={ariaLabel}
      className={`png-file-icon ${className}`}
      height={size}
      src={ASSET_PATHS.PNG_FILE_ICON}
      width={size}
    />
  );
}

export default PNGFileIcon;
